<bp-header *ngIf="user$ | async as user" [user]="user"> </bp-header>
<router-outlet></router-outlet>
